import { h } from 'preact'
import Moment from 'moment'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const Project = (props) => {

    let project = props.project

    if (typeof project.branch_names === 'undefined') {
        project.branch_names = []
    }

    let title = project.title.rendered
    let branches = project.branch_names.join(', ')
    let link = project.link
    let excerpt = project.excerpt.rendered
    let raw_date = project.date
    let date = Moment(raw_date).format('DD/MM/YYYY')
    let feat_image = project.feat_image

    let text_show = 'Bekijk'

    if (props.language == 'en') {
        text_show = 'View'
        date = Moment(raw_date).format('MM/DD/YYYY')
    }

    date = <div className="c-project__date">{date}</div>

    return (
        <div className="c-project c-projects__col">

            <div className="c-project__image u-image">
                <a href={link}
                   dangerouslySetInnerHTML={{ __html: feat_image }}/>
            </div>

            <div className="c-project__body">
                <h3 className="c-project__title">
                    <a
                        href={link}
                        className="c-project__link"
                        dangerouslySetInnerHTML={{ __html: title }}
                    />
                </h3>
                <div
                    className="c-project__excerpt"
                    dangerouslySetInnerHTML={{ __html: excerpt }}
                />
            </div>

            <div className="c-project__footer">

                <div className="c-project__details">
                    {date}

                    <div
                        className="c-project__branches"
                        style="text-align: right;"
                    >
                        {project.source}
                    </div>
                </div>

                <div className="c-project__view">
                    <a href={link}
                       className="c-button c-project__button"
                       target="_blank">
                        {text_show}
                        <svg class="c-icon c-icon--large c-project__icon">
                            <use href="#arrow-thin-right"
                                 xlinkHref="#arrow-thin-right"></use>
                        </svg>
                    </a>
                </div>

            </div>

        </div>
    )
}

export default Project

// WEBPACK FOOTER //
// ./src/js/projects/components/Project.js
